import React, { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { PeopleChartTeamSelectorFragment } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import TeamSelector from '.'

type WrapperProps = {
  onChange: (teamId: string) => void
  onAddTeamClicked: () => void
  teams: PeopleChartTeamSelectorFragment[]
}

const Wrapper: FC<WrapperProps> = ({ onChange, onAddTeamClicked, teams }) => {
  return (
    <Box
      overflowY="auto"
      style={{
        position: 'absolute',
        top: '60%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
      gap="s16"
    >
      <Callout description={i18n.t('people_chart.empty_state.title')} type="info" compact />
      <TeamSelector onChange={onChange} onAddTeamClicked={onAddTeamClicked} teams={teams} />
    </Box>
  )
}

export default Wrapper
